import angular from 'angular';
import 'angular-bootstrap';
import 'leaflet';
import 'leaflet-draw';
import 'leaflet.awesome-markers';
import 'leaflet.awesome-markers/dist/leaflet.awesome-markers.css';
import locales from '../../locale';
import './levelsServices';
import './levelsMapService';
// import 'Leaflet.Snap';
import '../../../scripts/leaflet-label-shim';

// ES6 modules are strict by default
const levelsControllers = angular.module('applicationModule.levelsControllers', [
    'applicationModule.levelsMapService',
    'applicationModule.levelsServices',
    'ui.bootstrap'
]);

// Levels List Controller
levelsControllers.controller('LevelsListController', ['$scope', '$rootScope', '$stateParams', 'NgTableParams', 'Level', 'growl', 'AppsoupAPI', 'Permissions', function ($scope, $rootScope, $stateParams, NgTableParams, Level, growl, AppsoupAPI, Permissions) {
    'use strict';

    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('levels');
    $scope.application_id = $stateParams.application_id;
    $scope.tableParams = new NgTableParams(AppsoupAPI.getDefaultTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return Level.getList($scope.application_id, params._params).then(function (response) {
                params.total(response.levels.total);
                params.count(response.levels.per_page);
                params.page(response.levels.current_page);
                return response.levels.data;
            }).finally(function () {
                $scope.isLoading = false;
            });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.remove = function ($event) {
        $event.stopImmediatePropagation();
    };

    $scope.removeLevel = function (id, index) {
        Level.remove(id).then(function (result) {
            let data = result.data;

            if (data.success) {
                growl.success('MODULES.LEVELS.SUCCESS.DELETE_LEVEL');
                $scope.tableParams.data.splice(index, 1);
            } else {
                growl.error('MODULES.LEVELS.ERROR.DELETE');
            }
        });
    };

    $scope.searchLevels = function (search) {
        var find = angular.copy(search);
        angular.extend($scope.tableParams._params, find);
    };

    $scope.clearSearch = function () {
        $scope.search = {};
        if (angular.isDefined($scope.tableParams._params.name)) {
            $scope.tableParams._params.name = undefined;
        }
    };
}]);

// Level Page Controller
levelsControllers.controller('LevelPageController', ['$scope', '$rootScope', '$stateParams', '$state', 'Level', 'growl', 'Permissions', function ($scope, $rootScope, $stateParams, $state, Level, growl, Permissions) {

    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('levels');
    $scope.application_id = $stateParams.application_id;
    $scope.editMode = false;

    $scope.level = {};

    var appId = $stateParams.application_id;

    $scope.level.app_id = appId;

    if (angular.isDefined($stateParams.levelId)) {
        $scope.editMode = true;
        $scope.isLoading = true;
        $rootScope.doingResolve = true;
        Level.get($stateParams.levelId, appId).then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.fileUploaded = true;
                $scope.level = data.level;
            } else {
                growl.error('MODULES.LEVELS.' + data.error);
            }
        }).catch(function () {
            $state.go('appsoup.application.levels', {application_id: appId}, growl.error('ERROR.EMPTY_DATA'));
        }).finally(function () {
            $scope.isLoading = false;
            $rootScope.doingResolve = false;
        });
    }

    $scope.ok = function () {
        $scope.$broadcast('show-errors-check-validity');
        if ($scope.levelForm.$valid) {
            $scope.level.application_id = appId;
            $scope.isLoading = true;
            Level.save($scope.level, $scope.editMode).then(function (result) {
                let data = result.data;

                if (data.success) {
                    $scope.fileError = false;
                    growl.success('MODULES.LEVELS.SUCCESS.' + ($scope.editMode ? 'LEVEL_UPDATED' : 'LEVEL_CREATED'));
                    $state.go('appsoup.application.levels', {application_id: appId});
                } else {
                    if (typeof data.error === 'object') {
                        if (data.error.image) {
                            $scope.fileError = true;
                        }
                        $scope.formErrors = data.error;
                    } else {
                        growl.error('MODULES.LEVELS.ERROR.LEVEL_CREATED');
                    }
                }
            }).finally(function () {
                $scope.isLoading = false;
            });
        }
    };

    $scope.cancel = function () {
        $state.go('appsoup.application.levels', {application_id: appId});
    };

    $scope.inputErrors = {
        'name': [{type: '$invalid', msg: 'MODULES.LEVELS.ERROR.REQUIRE.NAME'}],
        'image': [{type: '$invalid', msg: 'MODULES.LEVELS.ERROR.REQUIRE.IMAGE'}]
    };
}]);

// Level Beacons Controller
levelsControllers.controller('LevelBeaconsController', ['$scope', '$rootScope', '$stateParams', '$modal', 'NgTableParams', 'LevelBeaconAPI', 'growl', 'AppsoupAPI', 'Permissions', 'MapService', 'LevelsMapService', function ($scope, $rootScope, $stateParams, $modal, NgTableParams, LevelBeaconAPI, growl, AppsoupAPI, Permissions, MapService, LevelsMapService) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.app_id = $stateParams.application_id;
    $scope.writeAccess = Permissions.hasWriteAccess('levels');
    $scope.application_id = $stateParams.application_id;
    $scope.levelId = $stateParams.levelId;
    $scope.drawEnabled = true;
    $scope.beacons = [];

    if (angular.isDefined($scope.levelId)) {
        LevelBeaconAPI.getBeacons($scope.levelId)
            .then(function (response) {
                if (response.data.success) {
                    $scope.level = response.data.level;
                    $scope.beacons = response.data.beacons;
                    $scope.map = LevelsMapService.initMap('place-map');

                    return LevelsMapService.loadPlan($scope.level);
                }
            })
            .then(function () {
                LevelsMapService.addBeacons($scope.beacons, $scope.level, $scope.writeAccess);
            })
            .finally(function () {
                $scope.map.fireEvent('resize');
            });
    }

    $scope.newBeacon = function () {
        if ($scope.writeAccess) {
            $scope.option = 'beacon';
            $scope.drawEnabled = false;
            LevelsMapService.enableBeaconDrawer();
        }
    };

    $scope.$on('elementDrawn', function (event, data) {
        if ($scope.writeAccess) {
            var layer = data.layer;
            if (data.type === 'marker') {
                var point = layer.getLatLng();

                var beaconModalInstance = $modal.open({
                    templateUrl: 'views/application/levels/components/modal/beacon.tpl.html',
                    controller: 'BeaconMapModalController',
                    resolve: {
                        modalData: function () {
                            return {
                                editMode: false,
                                layer: layer,
                                beacon: {
                                    point_x_y: MapService.pointFromLatLng(point, $scope.level)
                                },
                                level_id: $scope.level.id,
                                app_id: $scope.app_id
                            };
                        }
                    }
                });

                beaconModalInstance.result.then(function (data) {
                    if (data) {
                        $scope.beacons.push(data);
                        LevelsMapService.newElement(layer);
                        LevelsMapService.updateElement(layer._leaflet_id, data, 'beacon');
                        $scope.onElementSaved();
                    }
                }, function () {
                    $scope.onElementSaved();
                }).catch(() => {});
            }
        }
    });

    $scope.onElementSaved = function () {
        $scope.option = undefined;
        $scope.drawEnabled = true;
    };

    $scope.deleteBeaconUser = function (userId, beaconId) {
        LevelBeaconAPI.deleteBeaconUser(userId, beaconId)
            .then(function (response) {
                if (response.data.success) {
                    angular.forEach($scope.beacons, function (val, key) {
                        if (val.id == beaconId) {
                            angular.forEach(val.users, function (v, k) {
                                if (k == userId) {
                                    delete $scope.beacons[key].users[k];
                                }
                            });
                        }
                    });
                }
            });
    };

    $scope.$on('elementSaved', function () {
        $scope.onElementSaved();
    });

    $scope.tableParams = new NgTableParams(AppsoupAPI.getDefaultTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return LevelBeaconAPI.getList($scope.levelId, params._params)
                .then(function (response) {
                    $scope.beacons = response.data.beacons.data;
                    if (angular.isDefined(response.data.success)) {
                        params.total(response.data.beacons.total);
                        params.count(response.data.beacons.per_page);
                        params.page(response.data.beacons.current_page);
                        return $scope.beacons;
                        $scope.types = response.data.types;
                        if (angular.isDefined($scope.level)) {
                            LevelsMapService.addBeacons($scope.beacons, $scope.level, $scope.writeAccess);
                        }
                    }
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        },
        counts: []
    });

    $scope.$on('$destroy', function () {
        LevelsMapService.removeMap();
    });

    $scope.$on('beaconEdit', function (e, beacon) {
        if ($scope.writeAccess) {
            var modalInstance = $modal.open({
                templateUrl: 'views/application/levels/components/modal/beacon.tpl.html',
                controller: 'BeaconMapModalController',
                resolve: {
                    modalData: function () {
                        return {
                            editMode: true,
                            beacon: beacon,
                            level_id: $scope.level.id,
                            app_id: $scope.app_id
                        };
                    }
                }
            });

            modalInstance.result.then(function (data) {
                if (data) {
                    $scope.editBeacon(data);
                    LevelsMapService.updateElement(beacon._leaflet_id, data, 'beacon');
                }
            }, function () {
                $scope.onElementSaved();
            }).catch(() => {});
        }
    });

    $scope.editBeacon = function (_beacon) {
        angular.forEach($scope.beacons, function (beacon, index) {
            if (beacon.id === _beacon.id) {
                $scope.beacons[index] = _beacon;
            }
        });
    };

    /**
     * Event po usunięciu beacona
     */
    $rootScope.$on('beaconRemoved', function (e, beacon) {
        angular.forEach($scope.beacons, function (b, index) {
            if (beacon.id == b.id)
                $scope.beacons.splice(index, 1);
        });
    });

    /**
     * Przerywa rysowanie beacona
     */
    $scope.cancel = function () {
        $scope.drawEnabled = true;
        $scope.$broadcast('show-errors-reset');
        LevelsMapService.cancelElement();
    };

}]);

// Beacon Map Modal Controller
levelsControllers.controller('BeaconMapModalController', ['$scope', '$modalInstance', '$rootScope', 'growl', 'modalData', 'LevelBeaconAPI', 'LevelsMapService', 'Permissions', function ($scope, $modalInstance, $rootScope, growl, modalData, LevelBeaconAPI, LevelsMapService, Permissions) {
    $scope.showAdvanced = Permissions.hasSuperAdminAccess();

    $scope.editMode = false;
    $scope.beacon = angular.copy(modalData.beacon);
    if (modalData.editMode) {
        $scope.editMode = true;
    }

    $scope.types = [];

    LevelBeaconAPI.getTypes()
        .then(function (res) {
            var response = res.data;
            if (response.success) {
                $scope.types = response.types;
                $scope.methods = response.methods;
            }
        });

    $scope.saveBeacon = function (beacon) {
        $scope.$broadcast('show-errors-check-validity');
        if ($scope.beaconForm.$valid) {
            var levelId = modalData.level_id;
            if (angular.isDefined(levelId)) {
                var beaconData = {
                    level_id: levelId,
                    name: beacon.name,
                    point_x_y: beacon.point_x_y
                };

                angular.extend(beaconData, beacon);
                beaconData.app_id = modalData.app_id;
            }

            if ($scope.editMode) {
                beaconData.id = beacon.id;
            }

            $scope.isLoading = true;
            LevelBeaconAPI.save(beaconData, $scope.editMode)
                .then(function (result) {
                    let data = result.data;

                    if (data.success) {
                        $modalInstance.close(data.beacon);
                        growl.success('MODULES.LEVELS.SUCCESS.BEACON.' + ($scope.editMode ? 'EDIT' : 'NEW'));
                        $scope.$emit('elementSaved');
                        $scope.$broadcast('show-errors-reset');
                    } else if (data.error) {
                        if (typeof data.error === 'object') {
                            $scope.formErrors = data.error;
                        } else {
                            growl.error(data.error);
                            $scope.cancel();
                            $scope.$emit('elementSaved');
                        }
                    }
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        }
    };

    $scope.deleteBeacon = function () {
        if (angular.isDefined($scope.beacon.id)) {
            $scope.isLoading = true;
            LevelBeaconAPI.remove($scope.beacon.id)
                .then(function (result) {
                    let data = result.data;

                    if (data.success) {
                        growl.success('MODULES.LEVELS.SUCCESS.BEACON.DELETE');
                        // Remove beacon from map
                        if (angular.isDefined($scope.beacon._leaflet_id)) {
                            LevelsMapService.removeElement($scope.beacon._leaflet_id);

                        } else {
                            throw new Error('Could not delete beacon from map, no _leaflet_id property!');
                        }
                        $rootScope.$broadcast('beaconRemoved', $scope.beacon);
                        $modalInstance.dismiss('BEACON_DELETED');
                        $scope.$emit('elementSaved');
                    } else if (data.error) {
                        if (typeof data.error === 'object') {
                            $scope.formErrors = data.error;
                        } else {
                            growl.error(data.error);
                        }
                    }
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        }
    };

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.inputErrors = {
        'name': [{type: '$invalid', msg: 'MODULES.LEVELS.ERROR.REQUIRE.BEACON'}],
        'params': [{error: 'required', msg: 'MODULES.LEVELS.ERROR.REQUIRE.PARAMS'}],
        'major': [{error: 'required', msg: 'FORM.ERRORS.REQUIRED'}],
        'minor': [{error: 'required', msg: 'FORM.ERRORS.REQUIRED'}]
    };
}]);

export default levelsControllers;
